import axiosInstance from '@/utils/api.js'

var state = {
  accountAcc: {},
  accountUSer: [],
  account_search: [],
  accounts_groups: [],
  accounts_group: [],
  accounts_in_group: [],
  list_accounts: [],
  list_acc_groups: [],
  list_all_acc_groups: [],
  acc_blocks: []
}

var getters = {
  ACCOUNT_ACC: (state) => {
    return state.accountAcc
  },
  ACCOUNT_USER: (state) => {
    return state.accountUSer
  },
  ACCOUNT_SEARCH: (state) => {
    return state.account_search
  },
  ACCOUNTS_GROUPS: (state) => {
    return state.accounts_groups
  },
  ACCOUNTS_GROUP: (state) => {
    return state.accounts_group
  },
  ACCOUNTS_IN_GROUP: (state) => {
    return state.accounts_in_group
  },
  ACCOUNTS_LIST: (state) => {
    return state.list_accounts
  },
  ACCOUNTS_GROUPS_LIST: (state) => {
    return state.list_acc_groups
  },
  ALL_ACCOUNTS_IN_GROUPS: (state, payload) => {
    return state.list_all_acc_groups
  },
  ACCOUNTS_BLOCKS: (state, payload) => {
    return state.acc_blocks
  }
}

var mutations = {
  SET_ACCOUNT_ACC: (state, payload) => {
    state.accountAcc = payload
  },
  SET_ACCOUNT_USER: (state, payload) => {
    state.accountUSer = payload
  },
  SET_ACCOUNT_SEARCH: (state, payload) => {
    state.account_search = payload
  },
  SET_ACCOUNTS_GROUPS: (state, payload) => {
    state.accounts_groups = payload
  },
  SET_ACCOUNTS_GROUP: (state, payload) => {
    state.accounts_group = payload
  },
  SET_ACCOUNTS_IN_GROUP: (state, payload) => {
    state.accounts_in_group = payload
  },
  SET_ACCOUNTS_LIST: (state, payload) => {
    state.list_accounts = payload
  },
  SET_ACCOUNTS_BY_AID: (state, payload) => {
    state.list_acc_groups = payload
  },
  SET_ALL_ACCOUNTS_IN_GROUPS: (state, payload) => {
    state.list_all_acc_groups = payload
  },
  SET_ACCOUNTS_BLOCKS: (state, payload) => {
    state.acc_blocks = payload
  }
}

var actions = {
  GET_ACCOUNT_ACC: async (context, payload) => {
    context.commit('SET_ACCOUNT_ACC', {})
    if (!payload) {
      return
    }
    let result = await axiosInstance.get('/users/accounts?account_id=' + payload)
    if (result.status === 200) {
      console.log(result)
      context.commit('SET_ACCOUNT_ACC', result.data)
    }
  },
  GET_BLOCKS_INFO: async (context, payload) => {
    let result = await axiosInstance.get('/users/blocks_info?account_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ACCOUNTS_BLOCKS', result.data)
    }
  },
  GET_ACCOUNTS_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/users/accounts_groups')
    if (result.status === 200) {
      context.commit('SET_ACCOUNTS_GROUPS', result.data)
    }
  },
  GET_ACCOUNTS_GROUPS_BY_AID: async (context, payload) => {
    let result = await axiosInstance.get('/users/accounts_groups_by_aid?account_id=' + payload.account_id)
    if (result.status === 200) {
      context.commit('SET_ACCOUNTS_BY_AID', result.data)
    }
  },
  LINK_GROUP_TO_ACC: async (context, payload) => {
    return axiosInstance.post('/users/link_groups_to_account', payload)
  },

  UPD_ACCOUNTS_GROUPS: async (context, payload) => {
    return axiosInstance.put('/users/accounts_groups', payload)
  },
  GET_ACCOUNTS_GROUP: async (context, payload) => {
    let result = await axiosInstance.get('/users/accounts_group?group_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ACCOUNTS_GROUP', result.data)
    }
  },
  GET_ACCOUNTS_LIST: async (context, payload) => {
    let result = await axiosInstance.get('/users/list_accounts?currentPage=' + payload.currentPage +
    '&perPage=' + payload.perPage +
    '&filter=' + payload.filter +
    '&sortField=' + payload.sortField +
    '&isDesc=' + payload.isDesc)
    if (result.status === 200) {
      context.commit('SET_ACCOUNTS_LIST', result.data)
    }
  },
  GET_ACCOUNT_USER: async (context, payload) => {
    let result = await axiosInstance.get('/users/accounts?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ACCOUNT_USER', result.data)
    }
  },
  GET_ACCOUNTS_IN_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/users/accounts_group_info?group_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ACCOUNTS_IN_GROUP', result.data)
    }
  },
  GET_ALL_ACCOUNTS_IN_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/users/accounts_all_groups')
    if (result.status === 200) {
      context.commit('SET_ALL_ACCOUNTS_IN_GROUPS', result.data)
    }
  },
  CREATE_ACCOUNT: (context, payload) => {
    return axiosInstance.post('/users/accounts', payload)
  },
  CREATE_ACCOUNTS_GROUPS: (context, payload) => {
    return axiosInstance.post('/users/accounts_groups', payload)
  },
  ADD_ACCOUNTS_TO_GROUPS: (context, payload) => {
    return axiosInstance.post('/users/link_account_group', payload)
  },
  CREATE_ACCOUNT_SEARCH: async (context, payload) => {
    let result = await axiosInstance.post('/users/accounts/search', payload)
    if (result.status === 200) {
      context.commit('SET_ACCOUNT_SEARCH', result.data)
    }
  },
  UPDATE_ACCOUNT: (context, payload) => {
    return axiosInstance.put('/users/accounts', payload)
  },
  DELETE_ACCOUNT: (context, payload) => {
    return axiosInstance.delete('/users/accounts?account_id=' + payload)
  },
  DELETE_ACCOUNTS_GROUP: (context, payload) => {
    return axiosInstance.delete('/users/accounts_groups?group_id=' + payload)
  },
  CHANGE_BALANCE: (context, payload) => {
    return axiosInstance.put('/users/change_account_balance', payload)
  },
  UNLINK_ACCOUNTS_FROM_GROUP: (context, payload) => {
    return axiosInstance.put('/users/unlink_accounts_group', payload)
  },
  UPD_ACCOUNTS_GROUP: (context, payload) => {
    return axiosInstance.put('/users/accounts_groups', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/accounts.js